import { Box } from '@mui/material';

interface ViewButtonProps {
  onClick: () => void;
  label?: string;
}

/**
 * The compact "View" pill — first built for Order Inbox, now the single
 * source of truth for that button everywhere it appears (Order Inbox, My
 * Network outstanding, etc). Fixed width/height so it renders identically
 * on every page — don't re-style this ad hoc per page; change it here.
 */
export function ViewButton({ onClick, label = 'View' }: ViewButtonProps) {
  return (
    <Box
      component="button"
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onClick();
      }}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 80,
        height: 22,
        flexShrink: 0,
        borderRadius: '5px',
        bgcolor: '#ede9fe',
        border: '1px solid #c4b5fd',
        color: '#7c3aed',
        fontSize: 11,
        fontWeight: 700,
        fontFamily: 'inherit',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        '&:hover': { bgcolor: '#ddd6fe', borderColor: '#a78bfa' },
      }}
    >
      {label}
    </Box>
  );
}
